import * as React from 'react';
import { VisitSummary } from '../../api/visits.types';

const PatientVisitsStateContext = React.createContext<[VisitSummary[], React.Dispatch<React.SetStateAction<VisitSummary[]>>] | undefined>(undefined);

export function PatientVisitsProvider({ children }: { children: React.ReactNode }) {
  const patientVisitsStates = React.useState<VisitSummary[]>([]);
  return <PatientVisitsStateContext.Provider value={patientVisitsStates}>{children}</PatientVisitsStateContext.Provider>;
}

export function usePatientVisits() {
  const context = React.useContext(PatientVisitsStateContext);
  if (context === undefined) {
    throw new Error('usePatientVisits must be used within a PatientVisitsProvider');
  }
  return context;
}
